module.exports = __webpack_public_path__ + "images/embed/bullet_plus_green.gif";